import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ERoutes } from "../components/layouts/Dashboard/dashboardLayout.interface";

type ShortcutHandler = (e: KeyboardEvent) => void;

export const useKeyboardShortcut = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleKeyPress: ShortcutHandler = (e) => {
      // Only handle if not in an input field
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        return;
      }

      // Check for 'W' key (go to Wholesale)
      if (
        e.key.toLowerCase() === "w" &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.altKey
      ) {
        e.preventDefault();
        navigate(ERoutes.Wholesale);
      }

      // Check for 'N' key (add new Wholesale)
      if (
        e.key.toLowerCase() === "n" &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.altKey
      ) {
        // Only navigate if we're already on the wholesale page
        if (location.pathname.startsWith("/wholesale")) {
          e.preventDefault();
          navigate("/wholesale/add");
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [navigate]);
};
